import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Utils from "@/utils";
import Upload from "../upload/Upload";
import ToGIFWork from "./children/ToGIFWork";
import actions from "@/redux/action";
import { withTranslation } from "react-i18next";

import "@/assets/toGIF.less";

class ToGIF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoAccept: "video/*,.mkv,.mov,.mp4,.avi,.wmv,.vob,.webm,.asf,.f4v,.flv,.mpg,.mpeg,.ts,.mxf,.ogv,.gif,.swf",
    };
  }

  initToGifObj = () => {
    const d = Utils.getSeconds(this.props.currFile.duration);
    console.log("d", d);
    const currFile = { ...this.props.currFile };
    let end;
    if (d < 30) {
      end = moment("00:00:00", "mm:ss:SS")
        .add(d, "seconds")
        .format("mm:ss:SS")
        .replace(/:([^:]*)$/, ".$1");
    } else {
      end = "00:30.00";
    }
    currFile.start = "00:00.00";
    currFile.end = end;
    this.props.onToGifObjChange(currFile);
  };

  componentDidMount() {
    if (this.props.currFile) {
      this.initToGifObj();
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.currFile) !== JSON.stringify(this.props.currFile)) {
      if (this.props.currFile && !prevProps.currFile) {
        this.initToGifObj();
      } else if (this.props.currFile && prevProps.currFile && this.props.currFile.videofileurl !== prevProps.currFile.videofileurl) {
        const toGifObj = { ...this.props.toGifObj };
        toGifObj.screenshots = this.props.currFile.screenshots;
        toGifObj.thumbnail = this.props.currFile.thumbnail;
        toGifObj.wh = this.props.currFile.wh;
        toGifObj.fps = this.props.currFile.fps;
        toGifObj.videofileurl = this.props.currFile.videofileurl;
        this.props.onToGifObjChange(toGifObj);
      }
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="ToGIF">
        <h1>{t("HitPaw Video to GIF Online")}</h1>
        <p>{t("Upload and convert video to GIF without any difficulty")}</p>
        {this.props.toGifObj ? (
          <ToGIFWork
            accept={this.props.type === "image" ? this.state.imageAccept : this.state.videoAccept + this.state.audioAccept}
            type={this.props.type}
          />
        ) : null}
        <Upload visible={this.props.toGifObj ? false : true} accept={this.state.videoAccept} work="togif" isUploadPreload addFileByUrlVisible />
      </div>
    );
  }
}

const mapStateToPropos = state => ({
  currFile: state.files.currFile,
  toGifObj: state.work.toGifObj,
});

const mapDispatchToProps = dispatch => ({
  onToGifObjChange: toGifObj => dispatch(actions.onToGifObjChange(toGifObj)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["toGIF"])(ToGIF));
